import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { FeedbackMessage } from '../interfaces/feedback-message.interface';

@Injectable({
  providedIn: 'root'
})
export class FeedbackMessageService {

  public feedbackMessage = new Subject<FeedbackMessage>();

  constructor() { }

  public give(message: FeedbackMessage): void {
    this.feedbackMessage.next(message);
  }
  
}
